import React from "react";

/**
* Organizes and formats the correct data about the item selected on the one to two day schedule. Displays the information based
* on what type of item has been selected. It gets this information based upon the itemDetails object that it is passed.
* @param {*ItemDetails} itemDetails
*/
const ItemModalDetails = ({ itemDetails, scheduleType, securityLevels }) => {
  const validateStatus = (status) => {
    return status != 1;/*None*/  
  }
  const { itemType } = itemDetails;
  let startTime = itemDetails.startTimeReal != undefined ? itemDetails.startTimeReal : itemDetails.startTime
  
  if (itemType === 'assignment') {
    const { resourceClass } = itemDetails;
    if (resourceClass === 'Facility') {
      return (
        <React.Fragment>
          <div><b>Start Time: </b>{startTime}</div>
          <div><b>End Time: </b>{itemDetails.endTime}</div>
          { validateStatus(securityLevels.secTTReqNum) ? <div><b>Request Number: </b>{itemDetails.requestNumber}</div>: '' }          
          { (validateStatus(securityLevels.laborFacilityInfo) && itemDetails.altResource) && <div><b>Resource: </b>{itemDetails.altResource}</div>}
          { validateStatus(securityLevels.scheduleTTService) ? <div><b>Service: </b>{itemDetails.service}</div> : '' }
          { validateStatus(securityLevels.scheduleTTBudgetCode) ? <div><b>Cost Object: </b>{itemDetails.costObject}</div> : '' }
          { validateStatus(securityLevels.scheduleTTBudgetCode) ? <div><b>Cost Object Number: </b>{itemDetails.costObjectNumber}</div>: '' }
          <div><b>Scheduler Comment: </b>{itemDetails.comment}</div>
          { validateStatus(securityLevels.jeDescription) ? <div><b>Description Comment: </b>{itemDetails.description}</div> : '' }
          <div><b>Cost on Facility: </b>{itemDetails.costOnFacility}</div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div><b>Start Time: </b>{startTime}</div>
          <div><b>End Time: </b>{itemDetails.endTime}</div>
          { validateStatus(securityLevels.secTTReqNum) ? <div><b>Request Number: </b>{itemDetails.requestNumber}</div>: '' }          
          { (validateStatus(securityLevels.laborFacilityInfo) && itemDetails.altResource) &&  <div><b>Facility: </b>{itemDetails.altResource}</div>}
          { validateStatus(securityLevels.scheduleTTService) ? <div><b>Service: </b>{itemDetails.service}</div> : '' }
          { validateStatus(securityLevels.scheduleJEContract) && itemDetails.assignmentContract ?<div><b>Assignment Contract: </b>{itemDetails.assignmentContract}</div>: ''}
          { validateStatus(securityLevels.scheduleTTBudgetCode) ? <div><b>Cost Object: </b>{itemDetails.costObject}</div> : '' }
          { validateStatus(securityLevels.scheduleTTBudgetCode) ? <div><b>Cost Object Number: </b>{itemDetails.costObjectNumber}</div>: '' }
          { (validateStatus(securityLevels.showOTReason) && itemDetails.overtimeReason) ? <div><b>Overtime Reason: </b>{itemDetails.overtimeReason}</div>: '' }
          <div><b>Scheduler Comment: </b>{itemDetails.comment}</div>
          { validateStatus(securityLevels.jeDescription) ? <div><b>Description Comment: </b>{itemDetails.description}</div> : '' }
        </React.Fragment>
      );
    }
  } else if (itemType === 'off-time') {
    return (
      <React.Fragment>
        <div><b>Day Type: </b>{itemDetails.abbreviation}</div>
        <div><b>Day Type Name: </b>{itemDetails.dayTypeName}</div>
        <div><b>Date: </b>{itemDetails.date}</div>
        <div><b>Day Comment: </b>{itemDetails.dayTypeComment}</div>
        { validateStatus(securityLevels.scheduleTTComments) ? <div><b>My Day Comment: </b>{itemDetails.myDayTypeComment}</div>: '' }
        { itemDetails.costCenter && itemDetails.showCostObjectId && validateStatus(securityLevels.tourCostCenter) ? <div><b>Cost Center: </b>{itemDetails.costCenter}</div>: '' }
        { itemDetails.wbse && itemDetails.showCostObjectId && validateStatus(securityLevels.tourWBSE)  ? <div><b>WBSE: </b>{itemDetails.wbse}</div>: '' }
      </React.Fragment>
    );
  } else if (itemType === 'off-request') {
    return (
      <React.Fragment>
        <div><b>Day Type Name: </b>{itemDetails.dayTypeName}</div>
        <div><b>Date: </b>{itemDetails.date}</div>
        {/* <div><b>Day Comment: </b>{itemDetails.dayTypeComment}</div> */} {/*  field is always null in live Schedules, so probably shouldn't have in posted */}
        { validateStatus(securityLevels.scheduleTTComments) ? <div><b>My Day Comment: </b>{itemDetails.myDayTypeComment}</div>: '' }
      </React.Fragment>
    );
  } else if (itemType === 'tour'
    || itemType === 'meal'
    || itemType === 'overtime'
  ) {
    return (
      <React.Fragment>
        <div><b>Day Type: </b>{itemDetails.dayTypeTitle}</div>
        {validateStatus(securityLevels.scheduleTourContract)&& itemDetails.tourContract ?<div><b>Tour Contract: </b>{itemDetails.tourContract}</div>: ''}
        <div><b>Tour Start Time: </b>{itemDetails.tourStartTime}</div>
        <div><b>Tour End Time: </b>{itemDetails.tourEndTime}</div>
        <div><b>Meal Start Time: </b>{itemDetails.mealStartTime}</div>
        <div><b>Meal End Time: </b>{itemDetails.mealEndTime}</div>
        <div><b>Notification Comment: </b>{itemDetails.notificationComment}</div>
        { validateStatus(securityLevels.scheduleTTComments) ? <div><b>Tour Comment: </b>{itemDetails.tourComment}</div> : '' }
        {scheduleType === 'liveSchedule' &&  validateStatus(securityLevels.scheduleTTComments) ? <div><b>My Tour Comment: </b>{itemDetails.myTourComment}</div> : ''}
        {itemDetails.costCenter && validateStatus(securityLevels.tourCostCenter) ? <div><b>Cost Center: </b>{itemDetails.costCenter}</div>: ''}
        {itemDetails.wbse && validateStatus(securityLevels.tourWBSE) ? <div><b>WBSE: </b>{itemDetails.wbse}</div>: '' }
      
      </React.Fragment>
    );
  } else return null;
}

export default ItemModalDetails;



// WEBPACK FOOTER //
// ./src/Components/Schedule/OneTwoDay/ItemModalDetails.js